"use client"

import { useState } from "react"
import styled from "styled-components"
import Card from "../ui/Card"
import Tabs from "../ui/Tabs"
import CoinTable from "../widgets/CoinTable"
import DominanceChart from "../widgets/DominanceChart"

const OverviewCard = styled(Card)`
  width: 100%;
`

const CardHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`

const CardTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
`

const CardDescription = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.secondaryText};
`

const CardContent = styled.div`
  padding: 16px;
`

const DominanceGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

const DominanceCardContainer = styled(Card)`
  padding: 16px;
`

const DominanceCardHeader = styled.div`
  margin-bottom: 8px;
`

const DominanceCardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
`

function MarketOverview() {
  const [activeTab, setActiveTab] = useState("coins")

  const tabs = [
    { id: "coins", label: "Coins" },
    { id: "dominance", label: "Dominance" },
  ]

  return (
    <OverviewCard>
      <CardHeader>
        <CardTitle>Market Overview</CardTitle>
        <CardDescription>Cryptocurrency market data and dominance charts</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
        <div style={{ marginTop: "16px" }}>
          {activeTab === "coins" && <CoinTable />}
          {activeTab === "dominance" && (
            <DominanceGrid>
              <DominanceCardContainer>
                <DominanceCardHeader>
                  <DominanceCardTitle>BTC Dominance</DominanceCardTitle>
                </DominanceCardHeader>
                <DominanceChart type="btc" />
              </DominanceCardContainer>

              <DominanceCardContainer>
                <DominanceCardHeader>
                  <DominanceCardTitle>ETH Dominance</DominanceCardTitle>
                </DominanceCardHeader>
                <DominanceChart type="eth" />
              </DominanceCardContainer>

              <DominanceCardContainer>
                <DominanceCardHeader>
                  <DominanceCardTitle>Stablecoin Dominance</DominanceCardTitle>
                </DominanceCardHeader>
                <DominanceChart type="usdt" />
              </DominanceCardContainer>
            </DominanceGrid>
          )}
        </div>
      </CardContent>
    </OverviewCard>
  )
}

export default MarketOverview

